// Helper para construir URLs hacia la app Next (que vive en el mismo TLD via
// balanceador). Las cookies httpOnly que setea Next viajan automáticamente
// gracias al credentials: 'include' / withCredentials: true.
//
// Usamos REACT_APP_BASE_URL (el dominio público de la SPA: propilatam.com /
// propilatam.dev) porque el balanceador sirve ambas apps ahí. Si la env no
// está seteada, default vacío = same-origin.

const NEXT_BASE = (process.env.REACT_APP_BASE_URL || '').replace(/\/+$/, '')

export const nextAuthUrl = (country: string, path: string): string => {
  const clean = path.replace(/^\/+/, '')
  return `${NEXT_BASE}/${country}/api/auth/${clean}`
}

export const nextProxyBase = (country: string): string => {
  return `${NEXT_BASE}/${country}/api/proxy`
}

export const nextProxyUrl = (country: string, path: string): string => {
  const clean = path.replace(/^\/+/, '')
  return `${nextProxyBase(country)}/${clean}`
}

// Refresh de la sesión customer (cookies httpOnly de Next).
//
// El proxy de Next NO refresca: sólo inyecta propi_session como Bearer. Cuando
// el access token vence (~10 min) el backend responde 401 aunque propi_refresh
// siga vivo. Antes de tratar un 401 como "deslogueado" pedimos a Next que rote
// las cookies y, si lo logra, el caller reintenta UNA vez.
//
// Mutex — múltiples 401 concurrentes comparten UNA sola llamada a /refresh (el
// backend rota el refresh token: dos refresh en paralelo con el mismo token
// dispararían el reuse-detection y revocarían la sesión). Se libera en el
// siguiente microtask para que 401 posteriores (sin relación con esta ronda)
// creen su propia Promise. Mismo patrón que `tryRefresh` en
// propi-web-nextjs/src/components/Auth/shared/apiClient.ts.
let refreshInFlight: Promise<boolean> | null = null

export const refreshNextSession = (country: string): Promise<boolean> => {
  if (refreshInFlight) return refreshInFlight
  refreshInFlight = (async () => {
    try {
      // El browser agrega Origin solo; Next lo valida como CSRF.
      const res = await fetch(nextAuthUrl(country, 'refresh'), {
        method: 'POST',
        credentials: 'include',
        cache: 'no-store',
      })
      // 2xx → cookies nuevas ya seteadas. Cualquier otro status → refresh falló.
      return res.ok
    } catch {
      // Red caída / CORS: no pudimos refrescar.
      return false
    } finally {
      queueMicrotask(() => {
        refreshInFlight = null
      })
    }
  })()
  return refreshInFlight
}

// Extrae el país de una URL del proxy/auth de Next (`.../{country}/api/proxy/...`).
export const countryFromNextUrl = (url: string): string | null => {
  const match = url.match(/\/([a-z]{2})\/api\/(?:proxy|auth)\//i)
  return match ? match[1].toLowerCase() : null
}
